import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { SortingState } from "@tanstack/react-table";
import AddUserTypeModal from "./AddUserTypeModal";
import {
  fetchUsersType,
  exportetchUsersTypes,
  updateStatusInUsersTypes,
  updateUsersTypes,
  UsersTypesxportsCSV,
} from "slices/userstypes/thunk";

// import {
//   exportOrganisationsCSV,
//   fetchOrganisations as OnfetchOrganisations,
//   updateOrganisation as onUpdateStatusInOrg
// } from 'slices/organisations/thunk'
import { toast } from "react-toastify";
import UsersTypeTableContainer from "./UsersTypeTable";
import { app_modules } from "helpers/apps_modules_list";
import { fetchLatestPermissions } from "slices/auth/login/thunk";
import LoaderErrorWrapper from "Components/LoaderErrorWrapper/LoaderErrorWrapper";
import SearchBox from "Components/SearchBox/SearchBox";

const UsersTypeList = () => {
  document.title = "User Type List";
  const dispatch = useDispatch<any>();

  const selectUserTypes = createSelector(
    (state: any) => {
      console.log("Redux state:", state); // <-- Add this
      return state.usersType;
    },
    (userTypesState) => ({
      list: userTypesState?.usersTypesList ?? [],
      rowCount: userTypesState?.rowCount ?? 0,
      loading: userTypesState?.loading ?? false,
      error: userTypesState?.error ?? null,
    })
  );

  const { list, rowCount, loading, error } = useSelector(selectUserTypes);

  const user = useSelector((state: any) => state.Login.user);
    const user_permissions = user?.permissions || [];
    const master_permissions = user_permissions?.find(
      (item: any) => item?.apps_name === app_modules?.user_management?.app_name
    );
    const user_types_permissions = master_permissions?.modules_permissions?.find(
      (item: any) =>
        item?.modules_name === app_modules?.user_management?.modules?.user_types
    );



  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [columnFilters, setColumnFilters] = useState<any>([]);
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [colValue, setColValue] = useState<any>();
  const [showModal, setShowModal] = useState(false);
  const [filterOptions, setFilterOptions] = useState<Record<string, any[]>>({});
  const [editData, setEditData] = useState<any>({});
  const [globalFilter, setGlobalFilter] = useState("");

  const sortField = sorting[0]?.id ?? "";
  const sortDirection = sorting[0]?.desc ? "desc" : "asc";

  useEffect(() => {
    dispatch(
      fetchUsersType({
        page: pageIndex + 1,
        pageSize,
        sort: sortField,
        order: sortField ? sortDirection : "",
        search,
        filters: columnFilters,
      })
    );
    console.log("API response from store:", fetchUsersType);
  }, [
    dispatch,
    pageIndex,
    pageSize,
    sorting,
    search,
    columnFilters,
    colValue,
    sortField,
    sortDirection,
  ]);

  // Reset to first page on filter, search, or page size change
  useEffect(() => {
    setPageIndex(0);
  }, [columnFilters, pageSize, search]);

  // Debounced search
  // Debounced search
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setSearch(searchInput);
      setPageIndex(0);
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchInput]);

  useEffect(() => {
    dispatch(
      fetchUsersType({
        page: pageIndex + 1,
        pageSize,
        sort: sortField,
        order: sortField ? sortDirection : "",
        search,
        filters: columnFilters,
      })
    );
  }, [
    dispatch,
    pageIndex,
    pageSize,
    sorting,
    search,
    columnFilters,
    sortField,
    sortDirection,
  ]);

  console.log("Data from store:", list, rowCount);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const result = await dispatch(fetchLatestPermissions()).unwrap();
      } catch (error) {
        console.error("Failed to fetch latest permissions", error);
        // toast.error("Failed to fetch latest permissions");
      }
    };
    fetchPermissions();
  }, [dispatch]);

  // Handle status toggle
  const handleStatusToggle = async (usertype: any) => {
    try {
      const updatedStatus = usertype.status === true ? false : true;
      const update_payload = { ...usertype, status: updatedStatus };
      await dispatch(updateStatusInUsersTypes(update_payload))
        .unwrap()
        .then(() => {
          toast.success(
            `UserType ${
              updatedStatus ? "activated" : "deactivated"
            } successfully`
          );
        });

      dispatch(
        fetchUsersType({
          page: pageIndex + 1,
          pageSize,
          sort: sortField,
          order: sortField ? sortDirection : "",
          search,
          filters: columnFilters,
        })
      );
    } catch (err) {
      toast.error("Failed to update status");
    }
  };
  const formatDate = (dateString?: string) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const handleAddUserType = async (userType: string) => {
    try {
      await dispatch(updateUsersTypes({ user_type: userType })).unwrap();
      toast.success("User Type added successfully");
      // Re-fetch data
      dispatch(
        fetchUsersType({
          page: pageIndex + 1,
          pageSize,
          sort: sortField,
          order: sortField ? sortDirection : "",
          search,
          filters: columnFilters,
        })
      );
    } catch (err) {
      toast.error("Failed to add User Type");
    }
  };

  const handleEdit = (rowData: any) => {
    setEditData(rowData);
    setShowModal(true);
  };

  const handleCreate = () => {
    setEditData(null);
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
    setEditData(null);
  };

  const DynamicAction =
    user_types_permissions?.permissions?.Update === true
      ? [
          {
            header: "Action",
            enableColumnFilter: false,
            enableSorting: false,
            cell: ({ row }: { row: any }) => (
              <ul className="d-flex gap-2 list-unstyled mb-0">
                <li>
                  <span
                    onClick={() => handleEdit(row?.original)}
                    className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                  >
                    <i className="ph-pencil"></i>
                  </span>
                </li>
              </ul>
            ),
          },
        ]
      : [];
  // Table columns
  const columns = useMemo(
    () => [
      // {
      //   header: "Sr. No.",
      //   id: "sr_no", // important: since there's no accessorKey
      //   enableSorting: false,
      //   enableColumnFilter: false,
      //   cell: ({ row }: { row: any }) => {
      //     return row.index + 1 + pageIndex * pageSize;
      //   },
      // },
      {
        header: " User Type",
        accessorKey: "user_type",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "dropdown" as const,
        filterFetchUrl:
          "api/usertype/column-filter-dropdown/?column_filter=user_type",
      },

      {
        header: "Status",
        accessorKey: "status",
        enableSorting: false, // Disables sorting
        enableColumnFilter: false, // Disables filtering
        cell: ({ row }: { row: any }) => {
          const org = row.original;
          return (
            <div
              style={{ fontSize: "1.5rem", cursor: "pointer" }}
              onClick={() => handleStatusToggle(org)}
            >
              <i
                className={`bi ${
                  org.status
                    ? "bi-toggle-on text-primary"
                    : "bi-toggle-off text-danger"
                }`}
              />
            </div>
          );
        },
      },

      {
        header: "Created Date",
        accessorKey: "created_at",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const name = row.original.created_by_name ?? "N/A";
          const date = formatDate(row.original.created_at);
          return `  ${name}  -  ${date}  `; // extra spaces for visual padding
        },
      },
      {
        header: "Updated Date",
        accessorKey: "updated_at",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const name = row.original.updated_by_name ?? "N/A";
          const date = formatDate(row.original.updated_at);
          return `  ${name}  -  ${date}  `; // spaces before/after the name
        },
      },
      ...DynamicAction,
    ],
    [dispatch, list, handleStatusToggle, user_types_permissions?.permissions]
  );

  return (
    <Fragment>
      <div className="page-content">
        <Container fluid>
          <Row id="invoiceList">
            <Col lg={12}>
              <Card>
                <Card.Header>
                  <Row className="align-items-center g-2">
                    <Col lg={3} className="me-auto">
                      <h6 className="card-title mb-0">Users Type List</h6>
                    </Col>

                    {/* Search Input Box (reusable)*/}
                    <Col xl={2} md={3}>
                      <SearchBox
                        value={searchInput}
                        onChange={setSearchInput}
                      />
                    </Col>

                    <Col className="col-md-auto">
                      <div className="hstack gap-2">
                        <Button
                          className="btn btn-subtle-danger d-none"
                          id="remove-actions"
                        >
                          <i className="ri-delete-bin-2-line"></i>
                        </Button>
                        {
                          user_types_permissions?.permissions?.Create === true && 
                        <Button
                          className="btn btn-primary"
                          onClick={() => setShowModal(true)}
                        >
                          Create User Type
                        </Button>
                        }
                      </div>
                    </Col>
                  </Row>
                </Card.Header>
                <Card.Body className="mt-3">
                  <LoaderErrorWrapper loading={loading} error={error}>
                    <UsersTypeTableContainer
                      columns={columns}
                      data={list}
                      totalRecords={rowCount}
                      pageIndex={pageIndex}
                      pageSize={pageSize}
                      onPageChange={setPageIndex}
                      onPageSizeChange={setPageSize}
                      columnFilters={columnFilters}
                      setColumnFilters={setColumnFilters}
                      colValue={setColValue}
                      sorting={sorting}
                      onSortingChange={setSorting}
                      manualSorting={true}
                      isBordered={false}
                      isPagination={true}
                      isGlobalFilter={false}
                      //filterOptions={filterOptions}
                      SearchPlaceholder="Search organisation..."
                    />
                  </LoaderErrorWrapper>

                  <AddUserTypeModal
                    key={editData?.user_type_id || "create"} // forces fresh instance
                    show={showModal}
                    handleClose={handleClose}
                    onSuccess={() =>
                      dispatch(fetchUsersType({ page: 1, pageSize: 10 }))
                    }
                    editData={editData}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default UsersTypeList;
